// extracted by mini-css-extract-plugin
module.exports = {"numText":"styles_numText__5O-eh","container":"styles_container__tc8Rr","iconWrapper":"styles_iconWrapper__2e9sV"};